module.exports = __webpack_public_path__ + "img/Savannah.2ed2355a.jpg";